import React, { useEffect } from 'react';
import { MainTable } from '../../Components/MainTable/MainTable';
import { useShops } from './ShopStore';
import Add from './Add';
import Edit from './Edit';

function Shops(props) {
    let { shops, columns, setEd, deleteShop, getShops } = useShops()
    useEffect(()=>{
        getShops()
    }, [getShops])
    return (
        <MainTable 
            pageTitle={'Magazinlar'}
            pdata={shops}
            pcolumns={columns}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteShop(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Shops;